export default __webpack_public_path__ + "static/GT-America-Extended-Bold-Italic-356fb35607ca72a68dcb794da4e2fd92.woff2";